var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2137 22.5525L24.18 11.5863L22.3975 9.8425L13.2137 19.0262L8.56375 14.3762L6.82 16.12L13.2137 22.5525ZM15.5 31C13.3817 31 11.3796 30.5931 9.49375 29.7794C7.60792 28.9656 5.96104 27.8548 4.55312 26.4469C3.14521 25.039 2.03437 23.3921 1.22062 21.5062C0.406875 19.6204 0 17.6183 0 15.5C0 13.3558 0.406875 11.3408 1.22062 9.455C2.03437 7.56917 3.14521 5.92875 4.55312 4.53375C5.96104 3.13875 7.60792 2.03437 9.49375 1.22062C11.3796 0.406875 13.3817 0 15.5 0C17.6442 0 19.6592 0.406875 21.545 1.22062C23.4308 2.03437 25.0713 3.13875 26.4662 4.53375C27.8612 5.92875 28.9656 7.56917 29.7794 9.455C30.5931 11.3408 31 13.3558 31 15.5C31 17.6183 30.5931 19.6204 29.7794 21.5062C28.9656 23.3921 27.8612 25.039 26.4662 26.4469C25.0713 27.8548 23.4308 28.9656 21.545 29.7794C19.6592 30.5931 17.6442 31 15.5 31ZM15.5 28.675C19.1683 28.675 22.2812 27.3898 24.8387 24.8194C27.3962 22.249 28.675 19.1425 28.675 15.5C28.675 11.8317 27.3962 8.71875 24.8387 6.16125C22.2812 3.60375 19.1683 2.325 15.5 2.325C11.8575 2.325 8.75104 3.60375 6.18062 6.16125C3.61021 8.71875 2.325 11.8317 2.325 15.5C2.325 19.1425 3.61021 22.249 6.18062 24.8194C8.75104 27.3898 11.8575 28.675 15.5 28.675Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPending);
export default __webpack_public_path__ + "static/media/check_pending.b253a2722ce1f7d9963f7f50656f02bd.svg";
export { ForwardRef as ReactComponent };